<template>
    <Head title="Materiais de Campanhas" />
    <AuthenticatedLayout>
        <Heading
            title="Materiais de Campanhas"
            class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28"
        />
        <div
            class="component-background-desktop component-background-mobile px-4 pb-4"
        >
            <section
                class="flex flex-col items-center xl:px-[15.5vw] min-h-[70vh]"
            >
                <div class="max-w-[718px] w-full p-4 bg-[#9A999E] bg-opacity-50 rounded-2xl gap-6 flex justify-center flex-wrap mt-4">
                    <button
                        class="
                        p-2
                        text-md
                        font-bold
                        text-center
                        border-primary border
                        rounded-3xl
                        min-w-[190px] 
                        "
                        :class="currentTab == 'M' ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-primary hover:text-white hover:border-transparent'"
                        @click="currentTab = 'M'"
                    >
                        Campanhas de Incentivo
                    </button>
                    <button
                        class="
                        p-2
                        text-md
                        font-bold
                        border-primary border
                        rounded-3xl
                        min-w-[190px]
                        "
                        :class="currentTab == 'G' ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-primary hover:text-white hover:border-transparent'"
                        @click="currentTab = 'G'"
                    >
                        Ganhadores
                    </button>
                    <button
                        class="
                        p-2
                        text-md
                        font-bold
                        border-primary border
                        rounded-3xl
                        min-w-[190px]
                        "
                        :class="currentTab == 'D' ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-primary hover:text-white hover:border-transparent'"
                        @click="currentTab = 'D'"
                    >
                        Dicas
                    </button>
                </div>
                <div class="flex flex-col gap-y-6 mt-8">
                    <Loading
                        :active="isLoadingPage?.length > 0"
                        :is-full-page="false"
                        :z-index="10"
                    />
                    <Campaign
                        v-for="(campaign, key) in mediaList"
                        :key="key"
                        :campaign="campaign"
                    />
                </div>
                <Pagination :total="totalPages ?? 0" :startPage="currentPage" :limit="1" @page:selected="setPage($event)"/>
            </section>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Campaign from "@/Components/Campaign.vue";
import Pagination from "@/Components/UI/Pagination.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Campaign,
        Pagination,
        Loading
    },

    data() {
        return {
            mediaList: [],
            currentTab: this.type || 'M',
            materialsPage: 0,
            winnersPage: 0,
            tipsPage: 0,
            totalPages: 0,
            isLoading: false,
            isLoadingPage: [],
        };
    },

    props: {
        materials: Object,
        winners: Object,
        tips: Object,
        type: String,
    },

    watch: {
        currentTab() {
            this.getMedias();
        },
    },

    computed: {
        medias() {
            let list = [];
            if (this.currentTab == 'M')
                list = this.materials;
            else if (this.currentTab == 'G')
                list = this.winners;
            else if (this.currentTab == 'D')
                list = this.tips;
            return list;
        },
        currentPage() {
            let list = 0;
            if (this.currentTab == 'M')
                list = this.materialsPage;
            else if (this.currentTab == 'G')
                list = this.winnersPage;
            else if (this.currentTab == 'D')
                list = this.tipsPage;
            return list;
        }
    },

    methods: {
        setPage(page) {
            if (this.currentTab == 'M')
                this.materialsPage = page;
            else if (this.currentTab == 'G')
                this.winnersPage = page;
            else if (this.currentTab == 'D')
                this.tipsPage = page;
            this.getMedias();
        },
        async getMedias() {
            const requestId = new Date().getTime();
            this.isLoadingPage = this.isLoadingPage.filter(
                (isLoadingObject) => isLoadingObject.requestId > requestId
            );
            this.isLoadingPage.push({
                requestId,
                loading: true,
            });
            this.isLoading = true;
            const type = this.currentTab;
            const page = this.currentPage
            
            axios.get(this.route('campaigns.data', { page, type, limiter: 3}))
                .then(({data}) => {
                    this.mediaList = data?.items ?? [];
                    this.totalPages = Math.floor((data.meta?.itemCount || 0) / (data.meta?.itemsPerPage || 3)) ?? 0;

                    const lastRequest = this.isLoadingPage.find(
                        (isLoadingObject) => isLoadingObject.requestId === requestId
                    );

                    if (lastRequest) {
                        this.isLoadingPage = [];
                        this.isLoading = false;
                    }
                });
        },
    },

    mounted() {
        this.getMedias();
    },
};
</script>
